import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class Chatbox {
	constructor(contentElement, inputField, sendButton) {
		this.list = contentElement.querySelector('ul');
		this.started = false;
		this.signupExists = false;
		this.contentElement = contentElement;

		helper.addEventListener(window, 'paytourClose', () => {
			this.signupExists = false;
		});

		helper.addEventListener(window, Events.START_ACTION, () => {
			this.started = true;
			let timing = 5;

			// Auto Messages
			setTimeout(() => { this._sendSystemWarning('Du musst mindestens 18 Jahre alt sein um diese Seite zu nutzen'); }, timing * 1000);
			setTimeout(() => { this._sendSystemWarning('Girls mit denen Du verbunden bist können Dich aktuell nicht sehen! Bitte bestätige Dein Alter!'); }, timing * 2000);
			setTimeout(() => { this._sendSystemWarning('Um verbunden zu bleiben und Nachrichten zu schicken musst Du zuerst einen kostenlosen Account erstellen, um Dein Alter zu bestätigen.'); }, timing * 3000);
		});

		helper.addEventListener(window, Events.CREATE_SIGNUP, () => {
			this.signupExists = true;
		});

		helper.addEventListener(inputField, 'keydown', (evt) => {
			if (evt.keyCode === 13) {
				this._sendMessage();
			}
		});

		helper.addEventListener(sendButton, 'click', (evt) => {
			evt.preventDefault();
			this._sendMessage();
		});
	}

	_sendMessage() {
		if (this.started && !this.signupExists) {
			this.list.appendChild(helper.stringToHtml('<li><div class="name guest">System</div><div class="comment">Deine Nachricht konnte nicht versendet werden. Bitte <a href="" class="paytour">erstelle einen Account</a>.</div></li>'));
			this._positionBox();
		}
		helper.triggerEvent(window, Events.CREATE_SIGNUP);
		helper.triggerEvent(window, Events.SENT_MESSAGE);
	}

	_sendSystemWarning(text) {
		if (this.started && !this.signupExists) {
			this.list.appendChild(helper.stringToHtml(`<li><div class="name guest">System</div><div class="comment warning">${text}</div></li>`));
			this._positionBox();
		}
	}

	_positionBox() {
		this.contentElement.scrollTop = this.contentElement.scrollHeight;
		this.list.scrollTop = this.list.scrollHeight;
	}
}
